// const config = {
//     public: {
//         dev_base: "https://beta-cezma.hmaserv.online",
//         prod_base: "https://api-v2.cezma.cloud"
//     }
// };
// const config = useRuntimeConfig();
// let hostUrl = process.env.NODE_ENV === "development" ? config.public.dev_base : config.public.prod_base

// Roles Notation:
// Main roles
//  admin - user
// ------------------
// Specific roles
// #admin
// - moderator
// - reseller
// - sub_reseller
// #user
// - user
// - reseller
// ------------------
// value names
//  admin >> admin
//     moderator_admin >> 'moderator'
//         reseller >> 'reseller'
//             moderator_reseller >> 'sub reseller'
//                 user >> 'user'

//root url requests
const ROOT_BASES = {
  firestore: `api`,
  raw: `api/v3`,
  user: `api/v3`,
  panel: `api/v3/panel`,
  admin: `api/v3/admin`,
  moderator: `api/v3/moderator`,
  reseller: `api/v3/reseller`,
  moderator_reseller: `api/v3/moderator_reseller`,
};
export const ROUTE_ROLES = {
  user: "user",
  admin: "admin",
  moderator_admin: "moderator",
  reseller: "reseller",
  moderator_reseller: "sub_reseller",
};

export const localStorageBasicData = Object.freeze({
  language: "ar",
  admin: {},
  user: {},
  isDarkMode: false,
  categories: [],
  favoriteProducts: [],
  paramOptions: {},
});

// methods names
const HTTP_METHODS = {
  post: "POST",
  get: "GET",
  delete: "DELETE",
  put: "PUT",
  patch: "PATCH",
};

// requestOwners
export const MAINROLES = {
  user: "user",
  admin: "admin",
};

export const SPECIFICROLES = {
  user: "user",
  admin: "admin",
  guest: "guest",
  moderator_admin: "moderator_admin",
  reseller: "reseller",
  moderator_reseller: "moderator_reseller",
};

export const LAYOUTS = {
  user: "user",
  admin: "admin",
  moderator_admin: "moderator-admin",
  reseller: "reseller",
  moderator_reseller: "moderator-reseller",
};

// API endpoints
export const APIREQUESTS = Object.freeze({
  general: {
    changeLanguage: {
      url: `${ROOT_BASES.user}/profile/change-language`,
      method: HTTP_METHODS.post,
    },

    refreshToken: {
      url: `${ROOT_BASES.user}/refresh-token`,
      method: HTTP_METHODS.post,
    },

    refreshFirebase: {
      url: `${ROOT_BASES.user}/refresh-token`,
      method: HTTP_METHODS.post,
    },
    paymentCallback: {
      url: `${ROOT_BASES.user}/callback`,
      method: HTTP_METHODS.post,
    },
    getWizardData: {
      url: `${ROOT_BASES.user}/wizard`,
      method: HTTP_METHODS.get,
    },
  },
  user: {
    deleteWithdrawalRequest: {
      url: `${ROOT_BASES.user}/withdrawal-requests`,
      method: HTTP_METHODS.delete,
    },
    updateWithdrawalRequest: {
      url: `${ROOT_BASES.user}/withdrawal-requests`,
      method: HTTP_METHODS.put,
    },
    reportWithdrawal: {
      url: `${ROOT_BASES.user}/withdrawal-requests/report`,
      method: HTTP_METHODS.post,
    },
    getWithdrawalRequests: {
      url: `${ROOT_BASES.user}/withdrawal-requests`,
      method: HTTP_METHODS.get,
    },
    sliderClicks: {
      url: `${ROOT_BASES.user}/sliders/click`,
      method: HTTP_METHODS.post,
    },
    createChatGroup: {
      url: `${ROOT_BASES.user}/google/firebase/store-create-group`,
      method: HTTP_METHODS.get,
    },
    makeDefaultAddress: {
      url: `${ROOT_BASES.user}/addresses`,
      method: HTTP_METHODS.put,
    },
    getAddresses: {
      url: `${ROOT_BASES.user}/addresses`,
      method: HTTP_METHODS.get,
    },
    createAddresses: {
      url: `${ROOT_BASES.user}/addresses`,
      method: HTTP_METHODS.post,
    },
    updateAddresses: {
      url: `${ROOT_BASES.user}/addresses`,
      method: HTTP_METHODS.put,
    },
    deleteAddresses: {
      url: `${ROOT_BASES.user}/addresses`,
      method: HTTP_METHODS.delete,
    },
    getLoggedDevices: {
      url: `${ROOT_BASES.user}/profile/devices`,
      method: HTTP_METHODS.get,
    },
    terminateDevice: {
      url: `${ROOT_BASES.user}/profile/devices`,
      method: HTTP_METHODS.delete,
    },
    deleteAccount: {
      url: `${ROOT_BASES.user}/google/firebase/logout-user`,
      method: HTTP_METHODS.get,
    },
    getAccounts: {
      url: `${ROOT_BASES.user}/google/firebase/get-user`,
      method: HTTP_METHODS.get,
    },
    submitAppeal: {
      url: `${ROOT_BASES.user}/notifications/reply`,
      method: HTTP_METHODS.post,
    },
    likeProductComment: {
      url: `${ROOT_BASES.user}/products/ratings/like`,
      method: HTTP_METHODS.post,
    },
    dislikeProductComment: {
      url: `${ROOT_BASES.user}/products/ratings/dislike`,
      method: HTTP_METHODS.post,
    },
    likeStoreComment: {
      url: `${ROOT_BASES.user}/stores/ratings/like`,
      method: HTTP_METHODS.post,
    },
    dislikeStoreComment: {
      url: `${ROOT_BASES.user}/stores/ratings/dislike`,
      method: HTTP_METHODS.post,
    },
    createChat: {
      url: `${ROOT_BASES.user}/google/firebase/create-group`,
      method: HTTP_METHODS.get,
    },
    authorizedOrder: {
      url: `${ROOT_BASES.user}/profile/authorized-order`,
      method: HTTP_METHODS.post,
    },
    getTokenFirestore: {
      url: `${ROOT_BASES.user}/google/firebase/get-authenticated-user`,
      method: HTTP_METHODS.get,
    },
    relatedStores: {
      url: `${ROOT_BASES.user}/profile/related-stores`,
      method: HTTP_METHODS.post,
    },
    lockStores: {
      url: `${ROOT_BASES.user}/profile/lock-stores`,
      method: HTTP_METHODS.post,
    },
    updateChatNotification: {
      url: `${ROOT_BASES.user}/profile/chat-notification`,
      method: HTTP_METHODS.post,
    },
    getStoresWithLocked: {
      url: `${ROOT_BASES.user}/profile/stores`,
      method: HTTP_METHODS.get,
    },

    addPasswordForStores: {
      url: `${ROOT_BASES.user}/profile/stores-password`,
      method: HTTP_METHODS.post,
    },
    profileConfig: {
      url: `${ROOT_BASES.user}/profile/config`,
      method: HTTP_METHODS.get,
    },
    getPointsData: {
      url: `${ROOT_BASES.user}/points`,
      method: HTTP_METHODS.get,
    },
    setPoints: {
      url: `${ROOT_BASES.user}/points`,
      method: HTTP_METHODS.post,
    },
    register: {
      url: `${ROOT_BASES.user}/register`,
      method: HTTP_METHODS.post,
    },
    registervalidation: {
      url: `${ROOT_BASES.user}/register-validation`,
      method: HTTP_METHODS.post,
    },
    otp: {
      url: `${ROOT_BASES.user}/otp`,
      method: HTTP_METHODS.post,
    },
    verify: {
      url: `${ROOT_BASES.user}/otp/verify`,
      method: HTTP_METHODS.post,
    },
    verifyPhone: {
      url: `${ROOT_BASES.panel}/verification/otp/verify`,
      method: HTTP_METHODS.post,
    },
    verifyPay: {
      url: `${ROOT_BASES.panel}/verification/pay`,
      method: HTTP_METHODS.post,
    },
    renewVerificationPay: {
      url: `${ROOT_BASES.panel}/verification/renew`,
      method: HTTP_METHODS.post,
    },
    cancelVerificationRequest: {
      url: `${ROOT_BASES.panel}/verification/cancel`,
      method: HTTP_METHODS.post,
    },
    resendOtp: {
      url: `${ROOT_BASES.user}/resend-otp`,
      method: HTTP_METHODS.post,
    },
    login: {
      url: `${ROOT_BASES.user}/login`,
      method: HTTP_METHODS.post,
    },
    forgotPassword: {
      url: `${ROOT_BASES.user}/forgot-password`,
      method: HTTP_METHODS.post,
    },
    resetPassword: {
      url: `${ROOT_BASES.user}/reset-password`,
      method: HTTP_METHODS.post,
    },
    logout: {
      url: `${ROOT_BASES.user}/logout`,
      method: HTTP_METHODS.post,
    },

    searchHistory: {
      url: `${ROOT_BASES.user}/search-history`,
      method: HTTP_METHODS.get,
    },
    editProductRating: {
      url: `${ROOT_BASES.user}/products/ratings`,
      method: HTTP_METHODS.put,
    },

    trendingNow: {
      url: `${ROOT_BASES.user}/categories`,
      method: HTTP_METHODS.get,
    },

    getCartData: {
      url: `${ROOT_BASES.user}/cart`,
      method: HTTP_METHODS.get,
    },

    getStoresFollowings: {
      url: `${ROOT_BASES.user}/stores/following`,
      method: HTTP_METHODS.get,
    },

    products: {
      url: `${ROOT_BASES.user}/products`,
      method: HTTP_METHODS.get,
    },
    // homepage
    getHomepageData: {
      url: `${ROOT_BASES.user}/home`,
      method: HTTP_METHODS.get,
    },
    //new homepage
    getNewHomepageData: {
      url: `${ROOT_BASES.user}/home`,
      method: HTTP_METHODS.get,
    },
    getProductRateDetails: {
      url: `${ROOT_BASES.user}/products/ratings`,
      method: HTTP_METHODS.get,
    },
    getStoreRateDetails: {
      url: `${ROOT_BASES.user}/stores/ratings`,
      method: HTTP_METHODS.get,
    },

    // wallet
    getWallet: {
      url: `${ROOT_BASES.user}/wallet`,
      method: HTTP_METHODS.get,
    },
    makePayment: {
      url: `${ROOT_BASES.user}/wallet/charge`,
      method: HTTP_METHODS.post,
    },
    // add product to favorites
    addToFavorite: {
      url: `${ROOT_BASES.raw}/favorites`,
      method: HTTP_METHODS.post,
    },
    // remove product from favorites
    removeFromFavorite: {
      url: `${ROOT_BASES.raw}/favorites`,
      method: HTTP_METHODS.delete,
    },
    // remove product from favorites
    getFavorites: {
      url: `${ROOT_BASES.user}/favorites`,
      method: HTTP_METHODS.get,
    },
    upgrade: {
      url: `${ROOT_BASES.user}/upgrade`,
      method: HTTP_METHODS.get,
    },
    checkout: {
      url: `${ROOT_BASES.user}/checkout`,
      method: HTTP_METHODS.post,
    },
    getStore: {
      url: `${ROOT_BASES.user}/stores`,
      method: HTTP_METHODS.get,
    },
    creatStore: {
      url: `${ROOT_BASES.user}/stores`,
      method: HTTP_METHODS.post,
    },
    updateStore: {
      url: `${ROOT_BASES.user}/stores`,
      method: HTTP_METHODS.post,
    },
    addProductRating: {
      url: `${ROOT_BASES.user}/products/ratings`,
      method: HTTP_METHODS.post,
    },
    deleteProductRating: {
      url: `${ROOT_BASES.user}/products/ratings`,
      method: HTTP_METHODS.delete,
    },
    reportProductRating: {
      url: `${ROOT_BASES.user}/products/ratings/report`,
      method: HTTP_METHODS.post,
    },
    addStoreRating: {
      url: `${ROOT_BASES.user}/stores/ratings`,
      method: HTTP_METHODS.post,
    },
    editStoreRating: {
      url: `${ROOT_BASES.user}/stores/ratings`,
      method: HTTP_METHODS.put,
    },
    deleteStoreRating: {
      url: `${ROOT_BASES.user}/stores/ratings`,
      method: HTTP_METHODS.delete,
    },
    getStoresFollowings: {
      url: `${ROOT_BASES.user}/stores/following`,
      method: HTTP_METHODS.get,
    },
    reportStoreRating: {
      url: `${ROOT_BASES.user}/stores/ratings/report`,
      method: HTTP_METHODS.post,
    },
    getStoreRatings: {
      url: `${ROOT_BASES.user}/stores/ratings`,
      method: HTTP_METHODS.get,
    },
    searchProducts: {
      url: `${ROOT_BASES.user}/website/search-products`,
      method: HTTP_METHODS.get,
    },
    searchStores: {
      url: `${ROOT_BASES.user}/website/search-stores`,
      method: HTTP_METHODS.get,
    },
    categories: {
      url: `${ROOT_BASES.user}/categories`,
      method: HTTP_METHODS.get,
    },
    allStores: {
      url: `${ROOT_BASES.user}/all-stores`,
      method: HTTP_METHODS.get,
    },
    reportProduct: {
      url: `${ROOT_BASES.user}/products/report`,
      method: HTTP_METHODS.post,
    },
    updateProfile: {
      url: `${ROOT_BASES.user}/profile`,
      method: HTTP_METHODS.post,
    },
    changePassword: {
      url: `${ROOT_BASES.user}/profile/change-password`,
      method: HTTP_METHODS.post,
    },
    getGovernorates: {
      url: `${ROOT_BASES.user}/governorates`,
      method: HTTP_METHODS.get,
    },
    getAreas: {
      url: `${ROOT_BASES.user}/areas`,
      method: HTTP_METHODS.get,
    },
    createOrder: {
      url: `${ROOT_BASES.user}/orders`,
      method: HTTP_METHODS.post,
    },
    createOrder: {
      url: `${ROOT_BASES.user}/orders`,
      method: HTTP_METHODS.post,
    },
    cancelOrder: {
      url: `${ROOT_BASES.user}/orders/cancel`,
      method: HTTP_METHODS.post,
    },
    getOrder: {
      url: `${ROOT_BASES.user}/orders`,
      method: HTTP_METHODS.get,
    },
    applyCoupon: {
      url: `${ROOT_BASES.user}/coupons`,
      method: HTTP_METHODS.get,
    },
    applyProductCoupon: {
      url: `${ROOT_BASES.user}/products/coupons`,
      method: HTTP_METHODS.get,
    },
    applyProductCouponCart: {
      url: `${ROOT_BASES.user}/cart`,
      method: HTTP_METHODS.post,
    },
    deleteProductCoupon: {
      url: `${ROOT_BASES.user}/cart`,
      method: HTTP_METHODS.delete,
    },
    createRetailOrder: {
      url: `${ROOT_BASES.user}/orders`,
      method: HTTP_METHODS.post,
    },
    notifications: {
      url: `${ROOT_BASES.user}/notifications`,
      method: HTTP_METHODS.get,
    },
    notificationMarkAsRead: {
      url: `${ROOT_BASES.user}/notifications/read`,
      method: HTTP_METHODS.post,
    },
    getNotificationTypes: {
      url: `${ROOT_BASES.user}/notifications/types`,
      method: HTTP_METHODS.get,
    },
    deleteNotifications: {
      url: `${ROOT_BASES.user}/notifications/delete`,
      method: HTTP_METHODS.post,
    },
    toggleNotifications: {
      url: `${ROOT_BASES.user}/notifications/enable`,
      method: HTTP_METHODS.post,
    },
    reportNotifications: {
      url: `${ROOT_BASES.user}/notifications/report`,
      method: HTTP_METHODS.post,
    },
    getUnreadCount: {
      url: `${ROOT_BASES.user}/unread_count`,
      method: HTTP_METHODS.get,
    },
    getChatContacts: {
      url: `${ROOT_BASES.user}/chats`,
      method: HTTP_METHODS.get,
    },
    deleteChatContent: {
      url: `${ROOT_BASES.user}/chats`,
      method: HTTP_METHODS.delete,
    },
    makeUserActive: {
      url: `${ROOT_BASES.user}/chats/active`,
      method: HTTP_METHODS.get,
    },
    // createChat: {
    //     url: `${ROOT_BASES.user}/chats`,
    //     method: HTTP_METHODS.post
    // },
    getChatMessages: {
      url: `${ROOT_BASES.user}/messages`,
      method: HTTP_METHODS.get,
    },
    sendMessage: {
      url: `${ROOT_BASES.user}/messages`,
      method: HTTP_METHODS.post,
    },
    markAsRead: {
      url: `${ROOT_BASES.user}/messages/read`,
      method: HTTP_METHODS.get,
    },
    contactUs: {
      url: `${ROOT_BASES.user}/contact-us`,
      method: HTTP_METHODS.post,
    },
    deleteSearchHistory: {
      url: `${ROOT_BASES.user}/search-history`,
      method: HTTP_METHODS.delete,
    },
    getLayout: {
      url: `${ROOT_BASES.user}/layout`,
      method: HTTP_METHODS.get,
    },
    getPrivacyPolicy: {
      url: `${ROOT_BASES.user}/privacy-policy`,
      method: HTTP_METHODS.get,
    },
    getTerms: {
      url: `${ROOT_BASES.user}/terms`,
      method: HTTP_METHODS.get,
    },
    getAboutUs: {
      url: `${ROOT_BASES.user}/about-us`,
      method: HTTP_METHODS.get,
    },
    getSeo: {
      url: `${ROOT_BASES.user}/seo`,
      method: HTTP_METHODS.get,
    },
    getCategorySeo: {
      url: `${ROOT_BASES.user}/categories/seo`,
      method: HTTP_METHODS.get,
    },
    recordClick: {
      url: `${ROOT_BASES.user}/ads/action/click`,
      method: HTTP_METHODS.get,
    },
    getFavoriteIDs: {
      url: `${ROOT_BASES.user}/favorites/ids`,
      method: HTTP_METHODS.get,
    },
    getCategories: {
      url: `${ROOT_BASES.user}/categories`,
      method: HTTP_METHODS.get,
    },
    getAttributes: {
      url: `${ROOT_BASES.user}/attributes`,
      method: HTTP_METHODS.get,
    },
    getStores: {
      url: `${ROOT_BASES.user}/stores`,
      method: HTTP_METHODS.get,
    },
    getProducts: {
      url: `${ROOT_BASES.user}/products`,
      method: HTTP_METHODS.get,
    },
    getExclusiveOffers: {
      url: `${ROOT_BASES.user}/exclusive-offers`,
      method: HTTP_METHODS.get,
    },
    getStoreNews: {
      url: `${ROOT_BASES.user}/stores/news`,
      method: HTTP_METHODS.get,
    },
    toggleStoreMutingState: {
      url: `${ROOT_BASES.user}/stores/follow/mute`,
      method: HTTP_METHODS.post,
    },
    getProductComments: {
      url: `${ROOT_BASES.user}/products/ratings`,
      method: HTTP_METHODS.get,
    },
    getSuggestions: {
      url: `${ROOT_BASES.user}/suggestions`,
      method: HTTP_METHODS.get,
    },

    addToCart: {
      url: `${ROOT_BASES.user}/cart`,
      method: HTTP_METHODS.post,
    },
    updateCartQuantity: {
      url: `${ROOT_BASES.user}/cart`,
      method: HTTP_METHODS.put,
    },
    getCartData: {
      url: `${ROOT_BASES.user}/cart`,
      method: HTTP_METHODS.get,
    },
    deleteCartItem: {
      url: `${ROOT_BASES.user}/cart`,
      method: HTTP_METHODS.delete,
    },
    placeOrderInCart: {
      url: `${ROOT_BASES.user}/cart/place-order`,
      method: HTTP_METHODS.post,
    },
    getCartAttributes: {
      // /cart/:id/attributes
      url: `${ROOT_BASES.user}/cart`,
      method: HTTP_METHODS.get,
    },
    updateCartAttributes: {
      // /cart/:id/attributes
      url: `${ROOT_BASES.user}/cart`,
      method: HTTP_METHODS.put,
    },
    applyCartCoupon: {
      // /cart/:id/coupon
      url: `${ROOT_BASES.user}/cart`,
      method: HTTP_METHODS.post,
    },
    applyStoreCoupon: {
      url: `${ROOT_BASES.user}/coupons`,
      method: HTTP_METHODS.get,
    },
    getRatings: {
      url: `${ROOT_BASES.user}/ratings`,
      method: HTTP_METHODS.get,
    },
    updateRating: {
      url: `${ROOT_BASES.user}/ratings`,
      method: HTTP_METHODS.put,
    },
    getProductsLogs: {
      url: `${ROOT_BASES.user}/activities`,
      method: HTTP_METHODS.get,
    },
    deleteLogItem: {
      url: `${ROOT_BASES.user}/activities/delete`,
      method: HTTP_METHODS.post,
    },
    getStoresOptionsRatings: {
      url: `${ROOT_BASES.user}/ratings/stores`,
      method: HTTP_METHODS.get,
    },
    cancelProductCoupon: {
      // /cart/:id/coupon
      url: `${ROOT_BASES.user}/cart`,
      method: HTTP_METHODS.delete,
    },
    followStore: {
      url: `${ROOT_BASES.user}/stores/follow`,
      method: HTTP_METHODS.post,
    },
    getAttributesFromCart: {
      url: `${ROOT_BASES.user}/cart`,
      method: HTTP_METHODS.get,
    },
    editDetailsOrder: {
      url: `${ROOT_BASES.user}/cart`,
      method: HTTP_METHODS.put,
    },
    deleteDetailsOrder: {
      url: `${ROOT_BASES.user}/cart/details`,
      method: HTTP_METHODS.delete,
    },
    addToCart: {
      url: `${ROOT_BASES.user}/cart`,
      method: HTTP_METHODS.post,
    },
    deleteProductFromCart: {
      url: `${ROOT_BASES.user}/cart`,
      method: HTTP_METHODS.delete,
    },
    getMyProfileInfo: {
      url: `${ROOT_BASES.raw}/profile`,
      method: HTTP_METHODS.get,
    },
    SendOtp: {
      url: `${ROOT_BASES.raw}/otp/send`,
      method: HTTP_METHODS.post,
    },
    verifyOtp: {
      url: `${ROOT_BASES.raw}/otp/verify`,
      method: HTTP_METHODS.post,
    },
    sendPhoneOTP: {
      url: `${ROOT_BASES.panel}/verification/otp/send`,
      method: HTTP_METHODS.post,
    },
    getStoreVerificationPrice: {
      url: `${ROOT_BASES.panel}/verification/price`,
      method: HTTP_METHODS.get,
    },
    getUserStores: {
      url: `${ROOT_BASES.raw}/panel/stores`,
      method: HTTP_METHODS.get,
    },
    deleteOrder: {
      url: `${ROOT_BASES.user}/orders`,
      method: HTTP_METHODS.delete,
    },
    verifyStore: {
      url: `${ROOT_BASES.panel}/verification`,
      method: HTTP_METHODS.post,
    },
    getStoreVerificationTerms: {
      url: `${ROOT_BASES.panel}/verification/terms`,
      method: HTTP_METHODS.get,
    },
  },
  // (the panel has conjoined roles including admins, moderators, resellers, sub-resellers)
  panel: {
    bulkVisibility: {
      url: `${ROOT_BASES.panel}/products/visible`,
      method: HTTP_METHODS.post,
    },
    ratingsReport: {
      url: `${ROOT_BASES.panel}/ratings/report`,
      method: HTTP_METHODS.post,
    },
    notificationLogsTypes: {
      url: `${ROOT_BASES.panel}/notification-logs/types`,
      method: HTTP_METHODS.get,
    },
    notificationLogs: {
      url: `${ROOT_BASES.panel}/notification-logs`,
      method: HTTP_METHODS.get,
    },
    adminsNotificationLogs: {
      url: `${ROOT_BASES.panel}/notification-logs/admins`,
      method: HTTP_METHODS.get,
    },
    clearNotificationLogs: {
      url: `${ROOT_BASES.panel}/notification-logs/clear`,
      method: HTTP_METHODS.post,
    },
    deleteNotificationLog: {
      url: `${ROOT_BASES.panel}/notification-logs`,
      method: HTTP_METHODS.delete,
    },
    getUnarchivedRequestsCount: {
      url: `${ROOT_BASES.panel}/unarchive-requests/count`,
      method: HTTP_METHODS.get,
    },
    getWithdrawalRequestsCount: {
      url: `${ROOT_BASES.panel}/withdrawal-requests/count`,
      method: HTTP_METHODS.get,
    },
    exportWithdrawalRequests: {
      url: `${ROOT_BASES.panel}/withdrawal-requests/export`,
      method: HTTP_METHODS.get,
    },
    getVerificationsCount: {
      url: `${ROOT_BASES.panel}/verifications/count`,
      method: HTTP_METHODS.get,
    },
    getAdsCount: {
      url: `${ROOT_BASES.panel}/ads/count`,
      method: HTTP_METHODS.get,
    },
    getAllStores: {
      url: `${ROOT_BASES.panel}/stores/all`,
      method: HTTP_METHODS.get,
    },
    deleteDevice: {
      url: `${ROOT_BASES.panel}/devices`,
      method: HTTP_METHODS.delete,
    },
    getStoresCoupons: {
      url: `${ROOT_BASES.panel}/stores/coupons`,
      method: HTTP_METHODS.get,
    },
    getLoggingDevices: {
      url: `${ROOT_BASES.panel}/devices`,
      method: HTTP_METHODS.get,
    },
    hasActiveStores: {
      url: `${ROOT_BASES.panel}/has-active-stores`,
      method: HTTP_METHODS.get,
    },
    updateSubAttributeSort: {
      url: `${ROOT_BASES.panel}/attributes/sort`,
      method: HTTP_METHODS.post,
    },
    getSubAttributeSort: {
      url: `${ROOT_BASES.panel}/attributes/sort`,
      method: HTTP_METHODS.get,
    },
    sendSMS: { url: `${ROOT_BASES.panel}/send-sms`, method: HTTP_METHODS.post },
    addBulkKeywords: {
      url: `${ROOT_BASES.panel}/search-keywords/bulk-keywords`,
      method: HTTP_METHODS.post,
    },
    moveToBlacklist: {
      url: `${ROOT_BASES.panel}/stores/blacklist`,
      method: HTTP_METHODS.post,
    },
    bulkMoveToBlacklist: {
      url: `${ROOT_BASES.panel}/stores/blacklist/bulk`,
      method: HTTP_METHODS.post,
    },
    bulkRestoreToWhitelist: {
      url: `${ROOT_BASES.panel}/stores/blacklist/restore/bulk`,
      method: HTTP_METHODS.post,
    },
    restoreToWhitelist: {
      url: `${ROOT_BASES.panel}/stores/blacklist/restore`,
      method: HTTP_METHODS.post,
    },
    getproduct: {
      url: `${ROOT_BASES.panel}/products`,
      method: HTTP_METHODS.get,
    },
    getProductById: {
      url: `${ROOT_BASES.panel}/products`,
      method: HTTP_METHODS.get,
    },
    getStoreGovernorates: {
      url: `${ROOT_BASES.panel}/stores/governorates`,
      method: HTTP_METHODS.get,
    },
    getStoreAreas: {
      url: `${ROOT_BASES.panel}/stores/areas`,
      method: HTTP_METHODS.get,
    },
    getproductAreas: {
      url: `${ROOT_BASES.panel}/products/areas`,
      method: HTTP_METHODS.get,
    },

    addStoreGovernorate: {
      url: `${ROOT_BASES.panel}/stores/governorates`,
      method: HTTP_METHODS.post,
    },
    editStoreGovernorate: {
      url: `${ROOT_BASES.panel}/stores/governorates`,
      method: HTTP_METHODS.put,
    },
    walletHistory: {
      url: `${ROOT_BASES.panel}/wallet-history`,
      method: HTTP_METHODS.get,
    },
    editProductGovernorate: {
      url: `${ROOT_BASES.panel}/products/governorates`,
      method: HTTP_METHODS.put,
    },
    getPreviousAttributes: {
      url: `${ROOT_BASES.panel}/products/previous-attributes`,
      method: HTTP_METHODS.get,
    },
    addStoreArea: {
      url: `${ROOT_BASES.panel}/stores/areas`,
      method: HTTP_METHODS.post,
    },
    addProductArea: {
      url: `${ROOT_BASES.panel}/products/areas`,
      method: HTTP_METHODS.post,
    },
    addProductGovernorate: {
      url: `${ROOT_BASES.panel}/products/governorates`,
      method: HTTP_METHODS.post,
    },
    editStoreArea: {
      url: `${ROOT_BASES.panel}/stores/areas`,
      method: HTTP_METHODS.put,
    },
    editProductArea: {
      url: `${ROOT_BASES.panel}/products/areas`,
      method: HTTP_METHODS.put,
    },
    deleteStoreArea: {
      url: `${ROOT_BASES.panel}/stores/areas`,
      method: HTTP_METHODS.delete,
    },
    deleteStoreGovernorate: {
      url: `${ROOT_BASES.panel}/stores/governorates`,
      method: HTTP_METHODS.delete,
    },

    deleteUnarchivedRequest: {
      url: `${ROOT_BASES.panel}/unarchive-requests`,
      method: HTTP_METHODS.delete,
    },
    changeStatusRequest: {
      url: `${ROOT_BASES.panel}/unarchive-requests`,
      method: HTTP_METHODS.put,
    },
    getUnarchivedRequests: {
      url: `${ROOT_BASES.panel}/unarchive-requests`,
      method: HTTP_METHODS.get,
    },
    changeWarningStatus: {
      url: `${ROOT_BASES.panel}/warnings`,
      method: HTTP_METHODS.put,
    },
    getCreatedByAdminNames: {
      url: `${ROOT_BASES.panel}/warnings/created-by-admin-names`,
      method: HTTP_METHODS.get,
    },
    createWarning: {
      url: `${ROOT_BASES.panel}/warnings`,
      method: HTTP_METHODS.post,
    },
    getWarnings: {
      url: `${ROOT_BASES.panel}/warnings`,
      method: HTTP_METHODS.get,
    },
    getStoreTags: {
      url: `${ROOT_BASES.panel}/hashtags`,
      method: HTTP_METHODS.get,
    },
    updateAd: { url: `${ROOT_BASES.panel}/ads`, method: HTTP_METHODS.put },
    getAdsViewsClicks: {
      url: `${ROOT_BASES.panel}/ads/activities`,
      method: HTTP_METHODS.post,
    },
    geteTotalSpentAds: {
      url: `${ROOT_BASES.panel}/ads/total-spends`,
      method: HTTP_METHODS.get,
    },
    updateStore: {
      url: `${ROOT_BASES.panel}/stores`,
      method: HTTP_METHODS.post,
    },
    creatStore: {
      url: `${ROOT_BASES.panel}/stores`,
      method: HTTP_METHODS.post,
    },
    getStore: { url: `${ROOT_BASES.panel}/stores`, method: HTTP_METHODS.get },
    generateStoreName: {
      url: `${ROOT_BASES.panel}/stores/generate-usernames`,
      method: HTTP_METHODS.get,
    },

    // add price
    getFollowers: {
      url: `${ROOT_BASES.panel}/followers`,
      method: HTTP_METHODS.get,
    },
    // ads
    getAdPrice: {
      url: `${ROOT_BASES.panel}/ads/prices`,
      method: HTTP_METHODS.get,
    },
    geteAds: { url: `${ROOT_BASES.panel}/ads`, method: HTTP_METHODS.get },
    createAd: { url: `${ROOT_BASES.panel}/ads`, method: HTTP_METHODS.post },
    changeAdStatus: {
      url: `${ROOT_BASES.panel}/ads/status`,
      method: HTTP_METHODS.post,
    },
    deleteAd: {
      url: `${ROOT_BASES.panel}/ads/delete`,
      method: HTTP_METHODS.post,
    },
    getOrderDetails: {
      url: `${ROOT_BASES.panel}/orders`,
      method: HTTP_METHODS.get,
    },

    // categories
    getMainCategories: {
      url: `${ROOT_BASES.panel}/categories`,
      method: HTTP_METHODS.get,
    },
    editMainCategory: {
      url: `${ROOT_BASES.panel}/categories`,
      method: HTTP_METHODS.post,
    },
    addMainCategory: {
      url: `${ROOT_BASES.panel}/categories`,
      method: HTTP_METHODS.post,
    },
    deleteMainCategory: {
      url: `${ROOT_BASES.panel}/categories`,
      method: HTTP_METHODS.delete,
    },
    //sub categories
    getSubCategories: {
      url: `${ROOT_BASES.panel}/categories`,
      method: HTTP_METHODS.get,
    },
    editSubCategory: {
      url: `${ROOT_BASES.panel}/categories`,
      method: HTTP_METHODS.put,
    },
    addSubCategory: {
      url: `${ROOT_BASES.panel}/categories`,
      method: HTTP_METHODS.post,
    },
    deleteSubCategory: {
      url: `${ROOT_BASES.panel}/categories`,
      method: HTTP_METHODS.delete,
    },
    // main attributes
    getMainAttributes: {
      url: `${ROOT_BASES.panel}/attributes`,
      method: HTTP_METHODS.get,
    },
    editMainAttribute: {
      url: `${ROOT_BASES.panel}/attributes`,
      method: HTTP_METHODS.post,
    },
    addMainAttribute: {
      url: `${ROOT_BASES.panel}/attributes`,
      method: HTTP_METHODS.post,
    },
    deleteMainAttribute: {
      url: `${ROOT_BASES.panel}/attributes`,
      method: HTTP_METHODS.delete,
    },
    //sub attributes
    getSubAttributes: {
      url: `${ROOT_BASES.panel}/attributes`,
      method: HTTP_METHODS.get,
    },
    editSubAttribute: {
      url: `${ROOT_BASES.panel}/attributes`,
      method: HTTP_METHODS.put,
    },
    addSubAttribute: {
      url: `${ROOT_BASES.panel}/attributes`,
      method: HTTP_METHODS.post,
    },
    deleteSubAttribute: {
      url: `${ROOT_BASES.panel}/attributes`,
      method: HTTP_METHODS.delete,
    },
    // packages
    getPackages: {
      url: `${ROOT_BASES.panel}/packages`,
      method: HTTP_METHODS.get,
    },
    editPackage: {
      url: `${ROOT_BASES.panel}/packages`,
      method: HTTP_METHODS.put,
    },
    addPackage: {
      url: `${ROOT_BASES.panel}/packages`,
      method: HTTP_METHODS.post,
    },
    deletePackage: {
      url: `${ROOT_BASES.panel}/packages`,
      method: HTTP_METHODS.delete,
    },
    // stores
    getStores: { url: `${ROOT_BASES.panel}/stores`, method: HTTP_METHODS.get },
    updateStores: {
      url: `${ROOT_BASES.panel}/stores`,
      method: HTTP_METHODS.put,
    },
    editStore: { url: `${ROOT_BASES.panel}/stores`, method: HTTP_METHODS.post },
    addStore: { url: `${ROOT_BASES.panel}/stores`, method: HTTP_METHODS.post },
    deleteStore: {
      url: `${ROOT_BASES.panel}/stores`,
      method: HTTP_METHODS.delete,
    },
    changeStoreStatus: {
      url: `${ROOT_BASES.panel}/stores`,
      method: HTTP_METHODS.put,
    },
    getFeature: { url: `${ROOT_BASES.panel}/stores`, method: HTTP_METHODS.get },
    getStoreCategories: {
      url: `${ROOT_BASES.panel}/categories`,
      method: HTTP_METHODS.get,
    },
    storeUpgrade: {
      url: `${ROOT_BASES.panel}/subscriptions/upgrade`,
      method: HTTP_METHODS.post,
    },
    // sub-resellers
    getSubResellers: {
      url: `${ROOT_BASES.panel}/moderator-resellers`,
      method: HTTP_METHODS.get,
    },
    addSubReseller: {
      url: `${ROOT_BASES.panel}/moderator-resellers`,
      method: HTTP_METHODS.post,
    },
    editSubReseller: {
      url: `${ROOT_BASES.panel}/moderator-resellers`,
      method: HTTP_METHODS.put,
    },
    deleteSubReseller: {
      url: `${ROOT_BASES.panel}/moderator-resellers`,
      method: HTTP_METHODS.delete,
    },
    // products
    getProducts: {
      url: `${ROOT_BASES.panel}/products`,
      method: HTTP_METHODS.get,
    },
    editProduct: {
      url: `${ROOT_BASES.panel}/products`,
      method: HTTP_METHODS.post,
    },
    moveProductsToAnotherStore: {
      url: `${ROOT_BASES.panel}/products/store`,
      method: HTTP_METHODS.post,
    },
    addProduct: {
      url: `${ROOT_BASES.panel}/products`,
      method: HTTP_METHODS.post,
    },
    pinProduct: {
      url: `${ROOT_BASES.panel}/products/pin`,
      method: HTTP_METHODS.post,
    },
    createImages: {
      url: `${ROOT_BASES.panel}/products/images/upload`,
      method: HTTP_METHODS.post,
    },
    deleteProduct: {
      url: `${ROOT_BASES.panel}/products`,
      method: HTTP_METHODS.delete,
    },
    editPricesBulk: {
      url: `${ROOT_BASES.panel}/products/edit-prices`,
      method: HTTP_METHODS.post,
    },
    addProductImage: {
      url: `${ROOT_BASES.panel}/products/images`,
      method: HTTP_METHODS.post,
    },
    deleteProductImage: {
      url: `${ROOT_BASES.panel}/products/images`,
      method: HTTP_METHODS.delete,
    },
    getProductReports: {
      url: `${ROOT_BASES.panel}/reports`,
      method: HTTP_METHODS.get,
    },
    clearReports: {
      url: `${ROOT_BASES.panel}/reports`,
      method: HTTP_METHODS.delete,
    },
    exportProductFile: {
      url: `${ROOT_BASES.panel}/products/excel/export`,
      method: HTTP_METHODS.get,
    },
    changeProductsAvailability:{
      url: `${ROOT_BASES.panel}/products/available`,
      method: HTTP_METHODS.post,
    },
    exportProductsFileTemplate: {
      url: `${ROOT_BASES.panel}/products/excel/export/template`,
      method: HTTP_METHODS.get,
    },
    importExcelProductFile: {
      url: `${ROOT_BASES.panel}/products/excel/import`,
      method: HTTP_METHODS.post,
    },

    bulkKeywords: {
      url: `${ROOT_BASES.panel}/products/keywords`,
      method: HTTP_METHODS.post,
    },
    multiProductsChangeCategory: {
      url: `${ROOT_BASES.panel}/products/category`,
      method: HTTP_METHODS.post,
    },
    // users
    getUsers: { url: `${ROOT_BASES.panel}/users`, method: HTTP_METHODS.get },
    addUser: { url: `${ROOT_BASES.panel}/users`, method: HTTP_METHODS.post },
    editUser: { url: `${ROOT_BASES.panel}/users`, method: HTTP_METHODS.put },
    deleteUser: {
      url: `${ROOT_BASES.panel}/users`,
      method: HTTP_METHODS.delete,
    },
    deleteUserEntirely: {
      url: `${ROOT_BASES.panel}/users/force-delete`,
      method: HTTP_METHODS.delete,
    },
    verifyUser: {
      url: `${ROOT_BASES.panel}/users/verify`,
      method: HTTP_METHODS.post,
    },
    // resellers
    getResellers: {
      url: `${ROOT_BASES.panel}/resellers`,
      method: HTTP_METHODS.get,
    },
    addReseller: {
      url: `${ROOT_BASES.panel}/resellers`,
      method: HTTP_METHODS.post,
    },
    editReseller: {
      url: `${ROOT_BASES.panel}/resellers`,
      method: HTTP_METHODS.put,
    },
    deleteReseller: {
      url: `${ROOT_BASES.panel}/resellers`,
      method: HTTP_METHODS.delete,
    },
    // logs
    getLogs: { url: `${ROOT_BASES.panel}/logs`, method: HTTP_METHODS.get },
    getLogActions: {
      url: `${ROOT_BASES.panel}/logs/actions`,
      method: HTTP_METHODS.get,
    },
    // governorates
    getGovernorates: {
      url: `${ROOT_BASES.panel}/governorates`,
      method: HTTP_METHODS.get,
    },
    addGovernorate: {
      url: `${ROOT_BASES.panel}/governorates`,
      method: HTTP_METHODS.post,
    },
    editGovernorate: {
      url: `${ROOT_BASES.panel}/governorates`,
      method: HTTP_METHODS.put,
    },
    deleteGovernorate: {
      url: `${ROOT_BASES.panel}/governorates`,
      method: HTTP_METHODS.delete,
    },
    // areas
    getAreas: { url: `${ROOT_BASES.panel}/areas`, method: HTTP_METHODS.get },
    addArea: { url: `${ROOT_BASES.panel}/areas`, method: HTTP_METHODS.post },
    editArea: { url: `${ROOT_BASES.panel}/areas`, method: HTTP_METHODS.put },
    deleteArea: {
      url: `${ROOT_BASES.panel}/areas`,
      method: HTTP_METHODS.delete,
    },
    // branches - it only belongs to the reseller and the sub-reseller
    getBranches: {
      url: `${ROOT_BASES.panel}/branches`,
      method: HTTP_METHODS.get,
    },
    addBranch: {
      url: `${ROOT_BASES.panel}/branches`,
      method: HTTP_METHODS.post,
    },
    editBranch: {
      url: `${ROOT_BASES.panel}/branches`,
      method: HTTP_METHODS.post,
    },
    deleteBranch: {
      url: `${ROOT_BASES.panel}/branches`,
      method: HTTP_METHODS.delete,
    },
    // coupons
    getCoupons: {
      url: `${ROOT_BASES.panel}/coupons`,
      method: HTTP_METHODS.get,
    },
    addCoupon: {
      url: `${ROOT_BASES.panel}/coupons`,
      method: HTTP_METHODS.post,
    },
    editCoupon: {
      url: `${ROOT_BASES.panel}/coupons`,
      method: HTTP_METHODS.post,
    },
    deleteCoupon: {
      url: `${ROOT_BASES.panel}/coupons`,
      method: HTTP_METHODS.delete,
    },
    //product coupons
    getProductCoupons: {
      url: `${ROOT_BASES.panel}/product-coupons`,
      method: HTTP_METHODS.get,
    },
    addProductCoupon: {
      url: `${ROOT_BASES.panel}/product-coupons`,
      method: HTTP_METHODS.post,
    },
    editProductCoupon: {
      url: `${ROOT_BASES.panel}/product-coupons`,
      method: HTTP_METHODS.post,
    },
    deleteProductCoupon: {
      url: `${ROOT_BASES.panel}/product-coupons`,
      method: HTTP_METHODS.delete,
    },
    // orders
    getOrders: { url: `${ROOT_BASES.panel}/orders`, method: HTTP_METHODS.get },
    editOrder: { url: `${ROOT_BASES.panel}/orders`, method: HTTP_METHODS.put },
    deleteOrder: {
      url: `${ROOT_BASES.panel}/orders`,
      method: HTTP_METHODS.delete,
    },
    changeBulkOrdersStatus: {
      url: `${ROOT_BASES.panel}/orders/bulk`,
      method: HTTP_METHODS.put,
    },
    exportOrder: {
      url: `${ROOT_BASES.panel}/orders/export`,
      method: HTTP_METHODS.get,
    },
    // withdrawal-requests
    getWithdrawal: {
      url: `${ROOT_BASES.panel}/withdrawal-requests`,
      method: HTTP_METHODS.get,
    },
    updateWithdrawal: {
      url: `${ROOT_BASES.panel}/withdrawal-requests`,
      method: HTTP_METHODS.put,
    },
    deleteWithdrawal: {
      url: `${ROOT_BASES.panel}/withdrawal-requests`,
      method: HTTP_METHODS.delete,
    },

    // news
    getNews: { url: `${ROOT_BASES.panel}/news`, method: HTTP_METHODS.get },
    addNews: { url: `${ROOT_BASES.panel}/news`, method: HTTP_METHODS.post },
    editNews: { url: `${ROOT_BASES.panel}/news`, method: HTTP_METHODS.post },
    deleteNews: {
      url: `${ROOT_BASES.panel}/news`,
      method: HTTP_METHODS.delete,
    },
    // packages invoices
    getInvoices: {
      url: `${ROOT_BASES.panel}/invoices`,
      method: HTTP_METHODS.get,
    },
    changeInvoiceStatus: {
      url: `${ROOT_BASES.panel}/invoices`,
      method: HTTP_METHODS.put,
    },
    deleteInvoice: {
      url: `${ROOT_BASES.panel}/invoices`,
      method: HTTP_METHODS.delete,
    },
    // my profile
    updateUserRoleProfile: {
      url: `${ROOT_BASES.panel}/profile`,
      method: HTTP_METHODS.post,
    },
    updateAdminRoleProfile: {
      url: `${ROOT_BASES.panel}/profile`,
      method: HTTP_METHODS.put,
    },
    // settings
    getWebsiteSettings: {
      url: `${ROOT_BASES.panel}/settings`,
      method: HTTP_METHODS.get,
    },
    updateWebsiteSettings: {
      url: `${ROOT_BASES.panel}/settings`,
      method: HTTP_METHODS.post,
    },
    managePushNotification: {
      url: `${ROOT_BASES.panel}/push-notification`,
      method: HTTP_METHODS.post,
    },
    sendAppReviewNotification: {
      url: `${ROOT_BASES.panel}/push-review`,
      method: HTTP_METHODS.post,
    },
    getMyProfileInfo: {
      url: `${ROOT_BASES.raw}/profile`,
      method: HTTP_METHODS.get,
    },
    updateUserRoleProfile: {
      url: `${ROOT_BASES.raw}/profile`,
      method: HTTP_METHODS.post,
    },
    updateAdminRoleProfile: {
      url: `${ROOT_BASES.raw}/profile`,
      method: HTTP_METHODS.put,
    },
    changePassword: {
      url: `${ROOT_BASES.raw}/change-password`,
      method: HTTP_METHODS.post,
    },
    deleteAccount: {
      url: `${ROOT_BASES.raw}/profile`,
      method: HTTP_METHODS.delete,
    },
    // reports
    downloadProductsReports: {
      url: `${ROOT_BASES.panel}/products/reports`,
      method: HTTP_METHODS.get,
    },
    downloadStoresReports: {
      url: `${ROOT_BASES.panel}/stores/reports`,
      method: HTTP_METHODS.get,
    },
    downloadOrdersReports: {
      url: `${ROOT_BASES.panel}/orders/reports`,
      method: HTTP_METHODS.get,
    },
    // manage offers - only belongs to the admin role
    getOffers: { url: `${ROOT_BASES.panel}/offers`, method: HTTP_METHODS.get },
    addOffer: { url: `${ROOT_BASES.panel}/offers`, method: HTTP_METHODS.post },
    editOffer: { url: `${ROOT_BASES.panel}/offers`, method: HTTP_METHODS.post },
    deleteOffer: {
      url: `${ROOT_BASES.panel}/offers`,
      method: HTTP_METHODS.delete,
    },
    // auth
    login: {
      url: `${ROOT_BASES.raw}/login`,
      method: HTTP_METHODS.post,
    },
    generate2fa: {
      url: `${ROOT_BASES.raw}/generate2fa`,
      method: HTTP_METHODS.post,
    },
    enable2fa: {
      url: `${ROOT_BASES.raw}/enable2fa`,
      method: HTTP_METHODS.post,
    },
    reset2fa: {
      url: `${ROOT_BASES.raw}/disable2fa`,
      method: HTTP_METHODS.post,
    },
    logout: {
      url: `${ROOT_BASES.raw}/logout`,
      method: HTTP_METHODS.post,
    },
    downloadOrdersFile: {
      url: `${ROOT_BASES.panel}/orders/export-file`,
      method: HTTP_METHODS.get,
    },
    requestProductRestore: {
      url: `${ROOT_BASES.panel}/products/unarchive-request`,
      method: HTTP_METHODS.post,
    },
    updateBulkProductsStatus: {
      url: `${ROOT_BASES.panel}/products/review`,
      method: HTTP_METHODS.post,
    },
    updateBulkProductsArchive: {
      url: `${ROOT_BASES.panel}/products/archive`,
      method: HTTP_METHODS.post,
    },
    deleteBulkProducts: {
      url: `${ROOT_BASES.panel}/products/delete`,
      method: HTTP_METHODS.post,
    },
    // keywords /search-keywords
    getSearchKeywords: {
      url: `${ROOT_BASES.panel}/search-keywords`,
      method: HTTP_METHODS.get,
    },
    addSeachKeywordItem: {
      url: `${ROOT_BASES.panel}/search-keywords`,
      method: HTTP_METHODS.post,
    },
    editSeachKeywordItem: {
      url: `${ROOT_BASES.panel}/search-keywords`,
      method: HTTP_METHODS.put,
    },
    deleteSeachKeywordItem: {
      url: `${ROOT_BASES.panel}/search-keywords`,
      method: HTTP_METHODS.delete,
    },
    updateKeywordReviewType: {
      url: `${ROOT_BASES.panel}/search-keywords/update-review-by-admin`,
      method: HTTP_METHODS.patch,
    },
    changeAIActivationStatus: {
      url: `${ROOT_BASES.panel}/search-keywords/run-ai`,
      method: HTTP_METHODS.post,
    },
    deactivate_keywords_AI: {
      url: `${ROOT_BASES.panel}/search-keywords/bulk-delete`,
      method: HTTP_METHODS.post,
    },
    checkAIActivationUpdate: {
      url: `${ROOT_BASES.panel}/search-keywords/ai/status`,
      method: HTTP_METHODS.get,
    },
    bulkKeywordsChangeCategory: {
      url: `${ROOT_BASES.panel}/search-keywords/bulk-categories`,
      method: HTTP_METHODS.post,
    },
    // Exclusive offers
    getExclusiveOffers: {
      url: `${ROOT_BASES.panel}/exclusive-offers`,
      method: HTTP_METHODS.get,
    },
    addExclusiveOffer: {
      url: `${ROOT_BASES.panel}/exclusive-offers`,
      method: HTTP_METHODS.post,
    },
    editExclusiveOffer: {
      url: `${ROOT_BASES.panel}/exclusive-offers`,
      method: HTTP_METHODS.put,
    },
    deleteExclusiveOffer: {
      url: `${ROOT_BASES.panel}/exclusive-offers`,
      method: HTTP_METHODS.delete,
    },
    // manage store verification requests
    getStoreVerificationRequests: {
      url: `${ROOT_BASES.panel}/verifications`,
      method: HTTP_METHODS.get,
    },
    deleteStoreVerificationRequest: {
      url: `${ROOT_BASES.panel}/verifications`,
      method: HTTP_METHODS.delete,
    },
    downloadStoreVerificationRequests: {
      url: `${ROOT_BASES.panel}/verifications/download`,
      method: HTTP_METHODS.get,
    },

    storesVerification: {
      url: `${ROOT_BASES.panel}/verification`,
      method: HTTP_METHODS.get,
    },
    // ratings
    getRatings: {
      url: `${ROOT_BASES.panel}/ratings`,
      method: HTTP_METHODS.get,
    },
    deleteRating: {
      url: `${ROOT_BASES.panel}/ratings/delete`,
      method: HTTP_METHODS.post,
    },
    // seo
    getSeo: { url: `${ROOT_BASES.panel}/seo`, method: HTTP_METHODS.get },
    updateSeo: { url: `${ROOT_BASES.panel}/seo`, method: HTTP_METHODS.post },
  },
  admin: {
    // manage admins - only belongs to the admin role
    getAdmins: { url: `${ROOT_BASES.panel}/admins`, method: HTTP_METHODS.get },
    addAdmin: { url: `${ROOT_BASES.panel}/admins`, method: HTTP_METHODS.post },
    editAdmin: { url: `${ROOT_BASES.panel}/admins`, method: HTTP_METHODS.put },
    deleteAdmin: {
      url: `${ROOT_BASES.panel}/admins`,
      method: HTTP_METHODS.delete,
    },
    // manage homepage main offers
    getHomepageOffers: {
      url: `${ROOT_BASES.panel}/groups`,
      method: HTTP_METHODS.get,
    },
    addHomepageOffer: {
      url: `${ROOT_BASES.panel}/groups`,
      method: HTTP_METHODS.post,
    },
    editHomepageOffer: {
      url: `${ROOT_BASES.panel}/groups`,
      method: HTTP_METHODS.put,
    },
    deleteHomepageOffer: {
      url: `${ROOT_BASES.panel}/groups`,
      method: HTTP_METHODS.delete,
    },
    // manage homepage sub offers
    getHomepageSubOffers: {
      url: `${ROOT_BASES.panel}/group-offers`,
      method: HTTP_METHODS.get,
    },
    addHomepageSubOffer: {
      url: `${ROOT_BASES.panel}/group-offers`,
      method: HTTP_METHODS.post,
    },
    editHomepageSubOffer: {
      url: `${ROOT_BASES.panel}/group-offers`,
      method: HTTP_METHODS.put,
    },
    deleteHomepageSubOffer: {
      url: `${ROOT_BASES.panel}/group-offers`,
      method: HTTP_METHODS.delete,
    },
    addOfferNewImage: {
      url: `${ROOT_BASES.panel}/group-offers/images`,
      method: HTTP_METHODS.post,
    },
    deleteHomepageSubOffersItem: {
      url: `${ROOT_BASES.panel}/group-offers/images`,
      method: HTTP_METHODS.delete,
    },
    // manage moderator-admins (moderators) - only belongs to the admin role
    getModerators: {
      url: `${ROOT_BASES.panel}/moderator-admins`,
      method: HTTP_METHODS.get,
    },
    addModerator: {
      url: `${ROOT_BASES.panel}/moderator-admins`,
      method: HTTP_METHODS.post,
    },
    editModerator: {
      url: `${ROOT_BASES.panel}/moderator-admins`,
      method: HTTP_METHODS.put,
    },
    deleteModerator: {
      url: `${ROOT_BASES.panel}/moderator-admins`,
      method: HTTP_METHODS.delete,
    },
    // dashboard
    getDashboardData: {
      url: `${ROOT_BASES.panel}/index`,
      method: HTTP_METHODS.get,
    },
    // wizard
    getWizardValues: {
      url: `${ROOT_BASES.panel}/settings?page=wizard`,
      method: HTTP_METHODS.get,
    },
    setWizardValues: {
      url: `${ROOT_BASES.panel}/settings`,
      method: HTTP_METHODS.post,
    },
    clearCash: {
      url: `${ROOT_BASES.panel}/clear-cache`,
      method: HTTP_METHODS.post,
    },
    editCreditToReseller: {
      url: `${ROOT_BASES.panel}/resellers/credit`,
      method: HTTP_METHODS.post,
    },
    editCreditToUsers: {
      url: `${ROOT_BASES.panel}/users/credit`,
      method: HTTP_METHODS.post,
    },
    // complaints
    suspendUser: {
      url: `${ROOT_BASES.panel}/complaints`,
      method: HTTP_METHODS.post,
    },
    getProductsComplaints: {
      url: `${ROOT_BASES.panel}/complaints/products`,
      method: HTTP_METHODS.get,
    },
    getComplaintsWithdrawalRequests: {
      url: `${ROOT_BASES.panel}/complaints/withdrawal-requests`,
      method: HTTP_METHODS.get,
    },
    updateComplaintsWithdrawalRequests: {
      url: `${ROOT_BASES.panel}/complaints/withdrawal-requests/status`,
      method: HTTP_METHODS.post,
    },
    deleteComplaintsWithdrawalRequests: {
      url: `${ROOT_BASES.panel}/complaints/withdrawal-requests`,
      method: HTTP_METHODS.delete,
    },
    getChatsComplaints: {
      url: `${ROOT_BASES.panel}/complaints/chats`,
      method: HTTP_METHODS.get,
    },
    updateProductComplaintDescription: {
      url: `${ROOT_BASES.panel}/complaints/products/description`,
      method: HTTP_METHODS.post,
    },
    updateStoresRatingsComplaintDescription: {
      url: `${ROOT_BASES.panel}/complaints/stores-ratings/description`,
      method: HTTP_METHODS.post,
    },
    updateNotificationsComplaintDescription: {
      url: `${ROOT_BASES.panel}/complaints/notifications/description`,
      method: HTTP_METHODS.post,
    },
    updateChatsComplaintDescription: {
      url: `${ROOT_BASES.panel}/complaints/chats/description`,
      method: HTTP_METHODS.post,
    },
    updateProductRatingComplaintDescription: {
      url: `${ROOT_BASES.panel}/complaints/products-ratings/description`,
      method: HTTP_METHODS.post,
    },
    getCountComplaints: {
      url: `${ROOT_BASES.panel}/complaints/count`,
      method: HTTP_METHODS.get,
    },
    reasonsProductsComplaints: {
      url: `${ROOT_BASES.panel}/complaints/products/reasons`,
      method: HTTP_METHODS.get,
    },
    getProductsRatingsComplaints: {
      url: `${ROOT_BASES.panel}/complaints/products-ratings`,
      method: HTTP_METHODS.get,
    },
    getStoresRatingsComplaints: {
      url: `${ROOT_BASES.panel}/complaints/stores-ratings`,
      method: HTTP_METHODS.get,
    },
    getNotificationsComplaints: {
      url: `${ROOT_BASES.panel}/complaints/notifications`,
      method: HTTP_METHODS.get,
    },
    deleteProductComplaint: {
      url: `${ROOT_BASES.panel}/complaints/products`,
      method: HTTP_METHODS.delete,
    },
    deleteProductRatingComplaint: {
      url: `${ROOT_BASES.panel}/complaints/products-ratings`,
      method: HTTP_METHODS.delete,
    },
    deleteStoreRatingComplaint: {
      url: `${ROOT_BASES.panel}/complaints/stores-ratings`,
      method: HTTP_METHODS.delete,
    },
    deleteNotificationComplaint: {
      url: `${ROOT_BASES.panel}/complaints/notifications`,
      method: HTTP_METHODS.delete,
    },
    deleteChatComplaint: {
      url: `${ROOT_BASES.panel}/complaints/chats`,
      method: HTTP_METHODS.delete,
    },
    updateProductComplaintStatus: {
      url: `${ROOT_BASES.panel}/complaints/products/status`,
      method: HTTP_METHODS.post,
    },
    updateProductRatingComplaintStatus: {
      url: `${ROOT_BASES.panel}/complaints/products-ratings/status`,
      method: HTTP_METHODS.post,
    },
    updateStoreRatingComplaintStatus: {
      url: `${ROOT_BASES.panel}/complaints/stores-ratings/status`,
      method: HTTP_METHODS.post,
    },
    updateNotificationComplaintStatus: {
      url: `${ROOT_BASES.panel}/complaints/notifications/status`,
      method: HTTP_METHODS.post,
    },
    updateChatComplaintStatus: {
      url: `${ROOT_BASES.panel}/complaints/chats/status`,
      method: HTTP_METHODS.post,
    },
    deleteComplaint: {
      url: `${ROOT_BASES.panel}/complaints`,
      method: HTTP_METHODS.delete,
    },
    showProductInHomeExclusiveOffers: {
      url: `${ROOT_BASES.panel}/products/exclusive-offers`,
      method: HTTP_METHODS.post,
    },
    countWarnings: {
      url: `${ROOT_BASES.panel}/warnings/count`,
      method: HTTP_METHODS.get,
    },
    seenRepliesWarnings: {
      url: `${ROOT_BASES.panel}/warnings`,
      method: HTTP_METHODS.put,
    },
  },
  // moderator_admin: {

  // },
  reseller: {
    //get descount coupons
    applyCoupon: {
      url: `${ROOT_BASES.panel}/stores/coupons`,
      method: HTTP_METHODS.get,
    },
    // pay for get a new store
    storeCheckout: {
      url: `${ROOT_BASES.panel}/subscriptions/new`,
      method: HTTP_METHODS.post,
    },

    upgradeSubscription: {
      url: `${ROOT_BASES.panel}/subscriptions/upgrade`,
      method: HTTP_METHODS.post,
    },

    // change package - only belongs to the reseller role
    upgradeSubscription: {
      url: `${ROOT_BASES.panel}/subscriptions/upgrade`,
      method: HTTP_METHODS.post,
    },
    renewSubscription: {
      url: `${ROOT_BASES.panel}/subscriptions/renew`,
      method: HTTP_METHODS.post,
    },
    downgradeSubscription: {
      url: `${ROOT_BASES.panel}/subscriptions/downgrade`,
      method: HTTP_METHODS.post,
    },
    cancelSubscription: {
      url: `${ROOT_BASES.panel}/subscriptions/downgrade`,
      method: HTTP_METHODS.delete,
    },

    autoRenewStore: {
      url: `${ROOT_BASES.panel}/stores`,
      method: HTTP_METHODS.put,
    },
  },
  // moderator_reseller: {

  // }
});

export const ROUTESNAMES = Object.freeze({
  user: {
    addresses: "/addresses",
    loggedDevices: "/security_settings",
    ratings: "/rating",
    otp: "/otp",
    login: "/login",
    homepage: "/",
    orders: "/orders",
    chats: "/chats",
    favourite: "/favourite",
    products: "/products",
    notifications: "/notifications",
    upgrade: "/upgrade",
    storeSettings: "/store-settings",
    deliveryLocations: "/delivery-locations",
    promotion: "/promotion",
    profile: "/profile",
    store: "/store",
    stores: "/stores",
    myStores: "/my-stores",
    myWallet: "/wallet",
    search: "/search",
    privacyPolicy: "/privacy-policy",
    termsCondition: "/terms-condition",
    aboutUs: "/about-us",
    contactUs: "/contact-us",
    categories: "/categories",
    cart: "/cart",
    verifyStore: "/verify_my_store",
    verificationProcess: "/verify_my_store/verification_process",
    upgradePayment: "/upgrade/payment",
    upgrade: "/upgrade",
    exclusiveOffers: "/exclusive_offers",
    news: "/news",
    followers: "/followers",
    followeres: "/followers",
    searchWithFilter: "/search/with-filter",
    follow_up: "/follow_up",
    activity_log: "/activity-log",
    rating_management: "/rating-management",
    win_with_cezma: "/win-with-cezma",
  },
  // panel - includes the admins, moderators, users, resellers, and sub-resellers.
  panel: {
    login: `/panel/login`,
    otp: `/panel/otp`,
  },
  //---- ADMIN ----
  admin: {
    delivery_governorates: `/${ROUTE_ROLES.admin}/delivery_governorates`,
    manageUnarchivedRequests: `/${ROUTE_ROLES.admin}/manage_unarchived_requests`,
    warnings: `/${ROUTE_ROLES.admin}/warnings`,
    homepage: `/${ROUTE_ROLES.admin}`,
    login: `/${ROUTE_ROLES.admin}/login`,
    dashboard: `/${ROUTE_ROLES.admin}/dashboard`,
    categories: `/${ROUTE_ROLES.admin}/categories`,
    attributes: `/${ROUTE_ROLES.admin}/attributes`,
    nestedMainAttributes: `/${ROUTE_ROLES.admin}/nested_main_attributes`,
    nestedSubAttributes: `/${ROUTE_ROLES.admin}/nested_sub_attributes`,
    packages: `/${ROUTE_ROLES.admin}/packages`,
    stores: `/${ROUTE_ROLES.admin}/stores`,
    products: `/${ROUTE_ROLES.admin}/products`,
    governorates: `/${ROUTE_ROLES.admin}/governorates`,
    admins: `/${ROUTE_ROLES.admin}/roles/admins`,
    users: `/${ROUTE_ROLES.admin}/roles/users`,
    moderators: `/${ROUTE_ROLES.admin}/roles/moderators`,
    resellers: `/${ROUTE_ROLES.admin}/roles/resellers`,
    subResellers: `/${ROUTE_ROLES.admin}/roles/sub_resellers`,
    coupons: `/${ROUTE_ROLES.admin}/coupons`,
    searchKeywords: `/${ROUTE_ROLES.admin}/search_keywords`,
    offers: `/${ROUTE_ROLES.admin}/offers`,
    orders: `/${ROUTE_ROLES.admin}/orders`,
    package_invoices: `/${ROUTE_ROLES.admin}/package_invoices`,
    mySettings: `/${ROUTE_ROLES.admin}/my_profile_settings`,
    manageWebsite: `/${ROUTE_ROLES.admin}/settings/manage_website`,
    managePoints: `/${ROUTE_ROLES.admin}/settings/manage-points`,
    manageSEO: `/${ROUTE_ROLES.admin}/settings/manage_SEO`,
    manageAds: `/${ROUTE_ROLES.admin}/settings/manage_Ads`,
    manageNotifications: `/${ROUTE_ROLES.admin}/settings/manage_notifications`,
    wizardHelpers: `/${ROUTE_ROLES.admin}/settings/wizard`,
    managePoliciesVerification: `/${ROUTE_ROLES.admin}/settings/manage_policies_verification`,
    productsReports: `/${ROUTE_ROLES.admin}/reports/products`,
    storesReports: `/${ROUTE_ROLES.admin}/reports/stores`,
    ordersReports: `/${ROUTE_ROLES.admin}/reports/orders`,
    homepageOffers: `/${ROUTE_ROLES.admin}/homepage_offers`,
    logs: `/${ROUTE_ROLES.admin}/logs`,
    exclusive_offers: `/${ROUTE_ROLES.admin}/exclusive_offers`,
    sponsored_ads: `/${ROUTE_ROLES.admin}/sponsored_ads`,
    manage_ads: `/${ROUTE_ROLES.admin}/manage_ads`,
    stores_verification_requests: `/${ROUTE_ROLES.admin}/stores_verification_requests`,
    manage_news: `/${ROUTE_ROLES.admin}/manage_news`,
    withdrawal_requests: `/${ROUTE_ROLES.admin}/withdrawal-requests`,
    manage_seo: `/${ROUTE_ROLES.admin}/manage_seo`,
    manage_complaints: `/${ROUTE_ROLES.admin}/manage_complaints`,
    notification_logs: `/${ROUTE_ROLES.admin}/notification-logs`,
  },
  //---- MODERATOR ----
  moderator_admin: {
    delivery_governorates: `/${ROUTE_ROLES.moderator_admin}/delivery_governorates`,
    warnings: `/${ROUTE_ROLES.moderator_admin}/warnings`,
    homepage: `/${ROUTE_ROLES.moderator_admin}`,
    login: `/${ROUTE_ROLES.moderator_admin}/login`,
    dashboard: `/${ROUTE_ROLES.moderator_admin}/dashboard`,
    // categories: `/${ROUTE_ROLES.moderator_admin}/categories`,
    // attributes: `/${ROUTE_ROLES.moderator_admin}/attributes`,
    // packages: `/${ROUTE_ROLES.moderator_admin}/packages`,
    stores: `/${ROUTE_ROLES.moderator_admin}/stores`,
    products: `/${ROUTE_ROLES.moderator_admin}/products`,
    // governorates: `/${ROUTE_ROLES.moderator_admin}/governorates`,
    users: `/${ROUTE_ROLES.moderator_admin}/roles/users`,
    resellers: `/${ROUTE_ROLES.moderator_admin}/roles/resellers`,
    subResellers: `/${ROUTE_ROLES.moderator_admin}/roles/sub_resellers`,
    // coupons: `/${ROUTE_ROLES.moderator_admin}/coupons`,
    orders: `/${ROUTE_ROLES.moderator_admin}/orders`,
    // package_invoices: `/${ROUTE_ROLES.moderator_admin}/package_invoices`,
    mySettings: `/${ROUTE_ROLES.moderator_admin}/my_profile_settings`,
    offers: `/${ROUTE_ROLES.moderator_admin}/offers`,
    productsReports: `/${ROUTE_ROLES.moderator_admin}/reports/products`,
    storesReports: `/${ROUTE_ROLES.moderator_admin}/reports/stores`,
    ordersReports: `/${ROUTE_ROLES.moderator_admin}/reports/orders`,
    logs: `/${ROUTE_ROLES.moderator_admin}/logs`,
    searchKeywords: `/${ROUTE_ROLES.moderator_admin}/search_keywords`,
    manage_complaints: `/${ROUTE_ROLES.moderator_admin}/manage_complaints`,
    exclusive_offers: `/${ROUTE_ROLES.moderator_admin}/exclusive_offers`,

  },
  //---- RESELLER ----
  reseller: {
    delivery_governorates: `/${ROUTE_ROLES.reseller}/delivery_governorates`,
    warnings: `/${ROUTE_ROLES.reseller}/warnings`,
    homepage: `/${ROUTE_ROLES.reseller}`,
    login: `/${ROUTE_ROLES.reseller}/login`,
    dashboard: `/${ROUTE_ROLES.reseller}/dashboard`,
    stores: `/${ROUTE_ROLES.reseller}/stores`,
    products: `/${ROUTE_ROLES.reseller}/products`,
    productCoupons: `/${ROUTE_ROLES.reseller}/product_coupons`,
    branches: `/${ROUTE_ROLES.reseller}/branches`,
    subResellers: `/${ROUTE_ROLES.reseller}/sub_resellers`,
    orders: `/${ROUTE_ROLES.reseller}/orders`,
    package_invoices: `/${ROUTE_ROLES.reseller}/package_invoices`,
    mySettings: `/${ROUTE_ROLES.reseller}/my_profile_settings`,
    productsReports: `/${ROUTE_ROLES.reseller}/reports/products`,
    storesReports: `/${ROUTE_ROLES.reseller}/reports/stores`,
    ordersReports: `/${ROUTE_ROLES.reseller}/reports/orders`,
    exclusive_offers: `/${ROUTE_ROLES.reseller}/exclusive_offers`,
    manage_ads: `/${ROUTE_ROLES.reseller}/manage_ads`,
    sponsored_ads: `/${ROUTE_ROLES.reseller}/sponsored_ads`,
    manage_news: `/${ROUTE_ROLES.reseller}/manage_news`,
    add_ads: `/${ROUTE_ROLES.reseller}/manage_ads/add`,
    stores_verification: `/${ROUTE_ROLES.reseller}/stores_verification`,
    manage_ratings: `/${ROUTE_ROLES.reseller}/manage_ratings`,
  },
  //---- SUB-RESELLER ----
  moderator_reseller: {
    delivery_governorates: `/${ROUTE_ROLES.moderator_reseller}/delivery_governorates`,
    warnings: `/${ROUTE_ROLES.moderator_reseller}/warnings`,
    homepage: `/${ROUTE_ROLES.moderator_reseller}`,
    login: `/${ROUTE_ROLES.moderator_reseller}/login`,
    dashboard: `/${ROUTE_ROLES.moderator_reseller}/dashboard`,
    stores: `/${ROUTE_ROLES.moderator_reseller}/stores`,
    products: `/${ROUTE_ROLES.moderator_reseller}/products`,
    branches: `/${ROUTE_ROLES.moderator_reseller}/branches`,
    orders: `/${ROUTE_ROLES.moderator_reseller}/orders`,
    mySettings: `/${ROUTE_ROLES.moderator_reseller}/my_profile_settings`,
    manage_news: `/${ROUTE_ROLES.moderator_reseller}/manage_news`,
    manage_ratings: `/${ROUTE_ROLES.moderator_reseller}/manage_ratings`,
    manage_ads: `/${ROUTE_ROLES.moderator_reseller}/manage_ads`,
    add_ads: `/${ROUTE_ROLES.moderator_reseller}/manage_ads/add`,
    stores_verification: `/${ROUTE_ROLES.moderator_reseller}/stores_verification`,
    exclusive_offers: `/${ROUTE_ROLES.moderator_reseller}/exclusive_offers`,
    productCoupons: `/${ROUTE_ROLES.moderator_reseller}/product_coupons`,
    package_invoices: `/${ROUTE_ROLES.moderator_reseller}/package_invoices`,
    notification_logs: `/${ROUTE_ROLES.moderator_reseller}/notification-logs`,
  },
  //---- ERROR PAGES ----
  errors: {
    _404: "/404",
    _401: "/401",
    _503: "/503",
  },
  //---- SUCCESS PAGES ----
  payment: {
    state: `/payment-state`,
  },
});
